import React from "react";
import { useTopOffenderFilter } from "./hooks";
import GeneralFilter from "../../../../components/Shared/Filter/GeneralFilter";
import { resetTopOffenderFilters } from "../../../../store/filters/topoffender/reducer";

const TopOffenderFilter: React.FC<{ onReset?: () => void; externalSearchActive?: boolean }> = ({ onReset, externalSearchActive }) => {
  const { dispatch, filters, formControlSx } = useTopOffenderFilter();

  return (
    <GeneralFilter
      dispatch={dispatch}
      filters={filters}
      formControlSx={formControlSx}
      resetFilters={resetTopOffenderFilters}
      showSearch={false}
      onReset={onReset}
      externalSearchActive={externalSearchActive}
    />
  );
};

export default TopOffenderFilter;
